import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;


export class contentInvestment_template extends vnTemplate{

    protected brandsFilter : multipleSelector_template;
    protected brandSegmentsFilter : multipleSelector_template;
    protected postInitiativesFilter : multipleSelector_template;
    protected postPaymentCategorySystemFilter: multipleSelector_template
    protected postIntentsFilter : multipleSelector_template;
    protected postContentTypesFilter : multipleSelector_template;
    protected articleTypesFilter : multipleSelector_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected primaryCategoriesFilter: filterMultipleAutoComplete_template;
    protected srEditorsFilter: filterMultipleAutoComplete_template;
    protected jrEditorsFilter: filterMultipleAutoComplete_template;
    protected datesFilter: filterDate_template;
    protected dimensionGrouping : multipleSelector_template;
    protected exportReportDataCsv: exportDataCsv;

    public toolTipActiveSessions: infoButton_template;
    public toolTipTotalRevenue: infoButton_template;
    public toolTipROI: infoButton_template;
    public toolTipSignUpRatio: infoButton_template;
    public toolTipActivityRatio: infoButton_template;

    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;
    protected brandSafetyFilter : multipleSelector_template;


    static dimensionGroupingItems : Array<{id : string, name : string, backendName: string, displayName:string }> = [
        { "id": "idBrand",  "name": "Brand", "backendName": "brand", "displayName" : "brandShortName"},
        { "id": "dateData",  "name": "Day", "backendName": "Day", "displayName" : "dateData"},
        { "id": "monthYear",  "name": "Month", "backendName": "monthYear", "displayName" : "dateData"},
        { "id": "idSegment",  "name": "Segment", "backendName": "segmentName", "displayName" : "segmentName"},
        { "id": "idInitiative",  "name": "Mapping", "backendName": "initiative", "displayName" : "initiativeName"},
        { "id": "idPostPaymentCategorySystem",  "name": "System", "backendName": "systemName", "displayName" : "postPaymentCategorySystemName"},
        { "id": "idIntent",  "name": "Intent", "backendName": "intent", "displayName" : "intentName"},
        { "id": "idContentType",  "name": "Content Type", "backendName": "content_type", "displayName" : "contentTypeName"},
        { "id": "articleType",  "name": "Page Type", "backendName": "article_type", "displayName" : "articleType"},
        { "id": "idPrimaryCategory",  "name": "Primary Category", "backendName": "primary_category", "displayName" : "primaryCategoryName"},
        { "id": "idNetworkCategory",  "name": "Network Category", "backendName": "network_category", "displayName" : "networkCategoryName"},
        { "id": "idEditor",  "name": "Sr Editor", "backendName": "sr_editor", "displayName" : "editorName"},
        { "id": "idJrEditor", "name": "Jr Editor", "backendName": "jr_editor", "displayName" : "jrEditorName"},
        { "id": "brandSafeCheck", "name": "Brand Safe Check", "backendName": "brandSafeCheck", "displayName" : "brandSafeCheck"},
    ];

    readonly contentTypesGroup : Array<{id : string, name : string}> = [
        { "id": "all", "name": "all"},
        { "id": "shortForm", "name": "Short"},
        { "id": "longForm", "name": "Long"}
    ];

    readonly publishStatus = [
        { "id": "all", "name": "all"},
        { "id": "publish", "name": "publish"},
        { "id": "republish", "name": "republish"}
    ];

    readonly articleTypes : Array<{id : string, name : string}> = [
        {"id": "Regular", "name": "Regular"},
        {"id": "Video", "name": "Video"},
        {"id": "Thread", "name": "Thread"},
    ];

    readonly dataRanges = [
        { "id": 30, "name": "30"},
        { "id": 60, "name": "60"},
        { "id": 90, "name": "90"},
        { "id": 180, "name": "180"},
        { "id": 360, "name": "360"},
        { "id": 720, "name": "720"},
    ];

    readonly brandSafety : Array<{id : string, name : string}> = [
        {"id": "unknown", "name": "Unknown"},
        {"id": "safe", "name": "Safe"},
        {"id": "partialUnsafe", "name": "Partial Unsafe"},
        {"id": "unsafe", "name": "Unsafe"},
    ];

    protected getTemplateHtml(): string{

        return  /*html*/`
            <div class="sub-header w-justify">

                ${this.presetFilter.getHtmlBuild()}

                <div class="w-left">
                    
                    <div class="multi-temp">${this.dimensionGrouping.getHtmlBuild()}</div>
                    ${this.brandsFilter.getHtmlBuild()}
                    ${this.brandSegmentsFilter.getHtmlBuild()}
                    ${this.postInitiativesFilter.getHtmlBuild()}
                    ${this.postIntentsFilter.getHtmlBuild()}
                    ${this.postContentTypesFilter.getHtmlBuild()}
                    ${this.articleTypesFilter.getHtmlBuild()}
                    ${this.networkCategoriesFilter.getHtmlBuild()}
                    ${this.postPaymentCategorySystemFilter.getHtmlBuild()} 
                    ${this.primaryCategoriesFilter.getHtmlBuild()}
                    ${this.srEditorsFilter.getHtmlBuild()}
                    ${this.jrEditorsFilter.getHtmlBuild()}
                    ${this.datesFilter.getHtmlBuild()}
                    
                    <div class="dropdown select-single">
                        <label class="form-label" for="">data Range (days)</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: dataRangeSelected"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: dataRanges">
                                    <input type="radio" data-bind="checked : $parent.dataRangeSelected, value: id,  attr: { 'id': 'data_range_' + id, 'name' : 'data_range_' + id }, event:{ change: $parent.onDataRangeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'data_range_' + id }, text: name"></label>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    
                    <div class="content-form-radio">
                        <div class="title" style="font-family:Lato, sans-serif">Form</div>
                        <form >
                            <div style="display: flex; gap:0.5rem" data-bind="foreach: formOptions">
                            <input type="radio" data-bind="checked : $parent.formOptionSelected, value: id,  attr: { 'id': 'form_' + id, 'name' : 'form_' + id }, event:{ change: $parent.onFormOptionChange}">
                            <label class="form-label" data-bind="attr: {for : 'form_' + id }, text: name"></label>
                            </div>
                        </form>
                    </div> 

                    <div class="dropdown select-single">
                        <label class="form-label" for="">Publishing type</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: publishStatusSelected"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: publishStatus">
                                    <input type="radio" data-bind="checked : $parent.publishStatusSelected, value: id,  attr: { 'id': 'pub_status_' + id, 'name' : 'pub_status_' + id }, event:{ change: $parent.onPublishStatusChange}">
                                    <label class="form-label" data-bind="attr: {for : 'pub_status_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                     <div>
                            ${this.brandSafetyFilter.getHtmlBuild()}
                    </div>
                </div>

            </div>
            
            ${this.validationsList.getHtmlBuild() }
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-dimensions"></div>
                   <div id="selected-brands"></div>
                   <div id="selected-brand-segments"></div>
                   <div id="selected-initiatives"></div>
                   <div id="selected-systems"></div>
                   <div id="selected-intents"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-article_types"></div>
                   <div id="selected-network_categories"></div>
                   <div id="selected-primary_categories"></div>
                   <div id="selected-sr-editors"></div>
                   <div id="selected-jr-editors"></div>
                   <div id="selected-brandSafety"></div>
                </div>   
            </div>
            
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-roi">Content Investment</h2>
                    <div>
                        <label class="toggle">
                            <span class="toggle-label" data-bind="css: (trafficSource() == 1) ? 'is-activated' : ''">GA4</span>
                            <input class="toggle-checkbox" data-bind="event: {change: onToggleTrafficSource}, checked: (trafficSource() == 2)" type="checkbox">
                            <div class="toggle-switch"></div>
                            <span class="toggle-label" data-bind="css: (trafficSource() == 2) ? 'is-activated' : ''">Sentinel</span>
                        </label>
                    </div>
                </div>
                <div class="w-right">
                    <button class="btn highlight icon fix-width i-expand" type="button" data-bind="class:  collapseButtonClass(), css: {'is-hidden': (collapseButtonHidden() || exportButtonHidden())} , text: collapseButtonText(), event: { click: onCollapseClick}">Simplify</button>
                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}, css: { 'is-hidden': exportButtonHidden(), 'is-loading': exportDataButtonClickable() == false  }">Export</button>
                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportReconciliationData}, css: { 'is-hidden': reconciliationPermissions() == false || exportReconciliationButtonHidden(), 'is-loading': reconciliationDataButtonClickable() == false }">Reconciliation Export</button>
                </div>
            </div>
                           
            <div class="w-list-results" id="list-results" style="padding-bottom: 200px">

                <table class="list-results list-sections thin no-shadow">
                    <thead>
                        <tr class="header list-header-section no-shadow">
                            <th data-bind="visible: dynamicHeadersList().length, attr: { colspan: dynamicHeadersList().length }"></th>
                            <th class="colgroup-1 start" data-bind="attr: { colspan: articleSectionColumnCount }"><span>Article</span></th>
                            <th class="colgroup-2 start" data-bind="attr: { colspan: engagementSectionColumnCount }"><span>Engagement</span></th>
                            <th class="colgroup-4 start" data-bind="attr: { colspan: overviewSectionColumnCount }"><span>Overview</span></th>
                        </tr>
                        <tr class="header flex-end-span">                     
                            <!-- ko foreach: dynamicHeadersList -->
                                <th class="align-right"><span class="icon list-sort-none" data-bind="text: name, event: { click: $parent.onClickReorder.bind($data, backendName) }, css: { 'list-sort-desc': $parent.orderByAndDirection()== backendName + '_DESC', 'list-sort-asc': $parent.orderByAndDirection()== backendName + '_ASC' }" class="icon i-dropdown-simple"></span></th>
                            <!-- /ko -->

                            <!-- Article -->
                            <th class="align-right colgroup-1 start"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': orderByAndDirection()=='articleCount_DESC', 'list-sort-asc': orderByAndDirection()=='articleCount_ASC' }" class="icon i-dropdown-simple" style="width: 75px;">Art.</span></th>
                            <th class="align-right colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'activeSessionsPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='activeSessionsPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='activeSessionsPerArticle_ASC' }" class="icon i-dropdown-simple">Act. Sess./Art.</span></th>

                            <!-- ko if: financialPermissions() -->
                                <th class="align-right colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sv') }, css: { 'list-sort-desc': orderByAndDirection()=='sv_DESC', 'list-sort-asc': orderByAndDirection()=='sv_ASC' }" class="icon i-dropdown-simple">SV</span></th>
                                <th class="align-right colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'rpm') }, css: { 'list-sort-desc': orderByAndDirection()=='rpm_DESC', 'list-sort-asc': orderByAndDirection()=='rpm_ASC' }" class="icon i-dropdown-simple">RPM</span></th>
                            <!-- /ko -->

                            <!-- ko if: financialPermissions() -->
                                <th class="align-right colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'cpm') }, css: { 'list-sort-desc': orderByAndDirection()=='cpm_DESC', 'list-sort-asc': orderByAndDirection()=='cpm_ASC' }" class="icon i-dropdown-simple">CPM</span></th>
                            <!-- /ko -->

                            <!-- ko if: financialPermissions() -->
                                <th class="align-right colgroup-1"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'revenuePerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='revenuePerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='revenuePerArticle_ASC' }" class="icon i-dropdown-simple">Rev./Art.</span></th>
                            <!-- /ko -->

                            <!-- ko if: costPermissions() && costBreakdownPermissions() -->
                                <th class="align-right colgroup-1" data-bind="visible: collapseButtonText() == 'simplify'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'writerCost') }, css: { 'list-sort-desc': orderByAndDirection()=='writerCost_DESC', 'list-sort-asc': orderByAndDirection()=='writerCost_ASC' }" class="icon i-dropdown-simple">Writer Cost</span></th>
                            <!-- /ko -->
                            
                            <!-- ko if: costPermissions() && costBreakdownPermissions() -->
                                <th class="align-right colgroup-1" data-bind="visible: collapseButtonText() == 'simplify'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'editorCost') }, css: { 'list-sort-desc': orderByAndDirection()=='editorCost_DESC', 'list-sort-asc': orderByAndDirection()=='editorCost_ASC' }" class="icon i-dropdown-simple">Editor Cost</span></th>
                            <!-- /ko -->

                            <!-- ko if: costPermissions() && costBreakdownPermissions() -->
                                <th class="align-right colgroup-1" data-bind="visible: collapseButtonText() == 'simplify'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'otherContentCost') }, css: { 'list-sort-desc': orderByAndDirection()=='otherContentCost_DESC', 'list-sort-asc': orderByAndDirection()=='otherContentCost_ASC' }" class="icon i-dropdown-simple">Other Content Cost</span></th>
                            <!-- /ko -->

                            <!-- ko if: costPermissions() -->
                                <th class="align-right colgroup-1 "><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'costPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='costPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='costPerArticle_ASC' }" class="icon i-dropdown-simple">C/A</span></th>
                            <!-- /ko -->

                            <!-- ko if: costPermissions() -->
                                <th class="align-right colgroup-1 "><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'grossProfitPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='grossProfitPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='grossProfitPerArticle_ASC' }" class="icon i-dropdown-simple">GP/A</span></th>
                            <!-- /ko -->

                            <!-- Engagement: AVD, Sign-up, Activity (Sentinel-only); Req./Sess., Imp./Sess. -->
                            <th class="align-right colgroup-2 start"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'averageViewDuration') }, css: { 'list-sort-desc': orderByAndDirection()=='averageViewDuration_DESC', 'list-sort-asc': orderByAndDirection()=='averageViewDuration_ASC' }" class="icon i-dropdown-simple">Average View Duration (S)</span></th>
                            <th class="align-right colgroup-2">
                                <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'signUpRatio') }, css: { 'list-sort-desc': orderByAndDirection()=='signUpRatio_DESC', 'list-sort-asc': orderByAndDirection()=='signUpRatio_ASC' }" class="faux-span icon i-dropdown-simple">Sign-up Ratio</span>
                                    <div class="w-tooltips-adv auto-height short pos-last">${this.toolTipSignUpRatio.getHtmlBuild()}</div>
                                </div>
                            </th>
                            <th class="align-right colgroup-2">
                                <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'activityRatio') }, css: { 'list-sort-desc': orderByAndDirection()=='activityRatio_DESC', 'list-sort-asc': orderByAndDirection()=='activityRatio_ASC' }" class="faux-span icon i-dropdown-simple">Activity Ratio</span>
                                    <div class="w-tooltips-adv auto-height short pos-last">${this.toolTipActivityRatio.getHtmlBuild()}</div>
                                </div>
                            </th>
                            <th class="align-right colgroup-2"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'requestsPerSession') }, css: { 'list-sort-desc': orderByAndDirection()=='requestsPerSession_DESC', 'list-sort-asc': orderByAndDirection()=='requestsPerSession_ASC' }" class="icon i-dropdown-simple">Req./Sess.</span></th>
                            <th class="align-right colgroup-2"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'impressionsPerSession') }, css: { 'list-sort-desc': orderByAndDirection()=='impressionsPerSession_DESC', 'list-sort-asc': orderByAndDirection()=='impressionsPerSession_ASC' }" class="icon i-dropdown-simple">Imp./Sess.</span></th>

                            <!-- Overview -->
                            <th class="align-right colgroup-4 start">
                                <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'activeSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='activeSessions_DESC', 'list-sort-asc': orderByAndDirection()=='activeSessions_ASC' }" class="faux-span icon i-dropdown-simple">
                                        Act. Sess.
                                    </span>
                                    <div class="w-tooltips-adv auto-height short pos-last">
                                    ${this.toolTipActiveSessions.getHtmlBuild()}
                                    </div>
                                </div>
                            </th>
                            <th class="align-right colgroup-4" data-bind="visible: collapseButtonText() == 'simplify'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'usActiveSessionsPercentage') }, css: { 'list-sort-desc': orderByAndDirection()=='usActiveSessionsPercentage_DESC', 'list-sort-asc': orderByAndDirection()=='usActiveSessionsPercentage_ASC' }" class="icon i-dropdown-simple">US Traffic%</span></th>

                            <!-- ko if: financialPermissions() -->
                                <th class="align-right colgroup-4">
                                    <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                        <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'revenue') }, css: { 'list-sort-desc': orderByAndDirection()=='revenue_DESC', 'list-sort-asc': orderByAndDirection()=='revenue_ASC' }" class="faux-span icon i-dropdown-simple">
                                            Act. Revenue
                                        </span>
                                        <div class="w-tooltips-adv auto-height short pos-last">
                                        ${this.toolTipTotalRevenue.getHtmlBuild()}
                                        </div>
                                    </div>
                                </th>
                            <!-- /ko -->

                            <!-- ko if: costPermissions() -->
                                <th class="align-right colgroup-4"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalCost') }, css: { 'list-sort-desc': orderByAndDirection()=='totalCost_DESC', 'list-sort-asc': orderByAndDirection()=='totalCost_ASC' }" class="icon i-dropdown-simple">Total  Cost</span></th>
                            <!-- /ko -->

                            <!-- ko if: costPermissions() -->
                                <th  class="align-right colgroup-4"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'costPerMilSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='costPerMilSessions_DESC', 'list-sort-asc': orderByAndDirection()=='costPerMilSessions_ASC' }" class="icon i-dropdown-simple">Cost/1k Sess.</span></th>
                            <!-- /ko -->

                            <!-- ko if: costPermissions() && financialPermissions() -->
                                <th class="align-right colgroup-4">
                                    <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                        <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'roi') }, css: { 'list-sort-desc': orderByAndDirection()=='roi_DESC', 'list-sort-asc': orderByAndDirection()=='roi_ASC' }" class="faux-span icon i-dropdown-simple">
                                            Act. Gross ROI%
                                        </span>
                                        <div class="w-tooltips-adv pos-last auto-height short">
                                        ${this.toolTipROI.getHtmlBuild()}
                                        </div>
                                    </div>
                                </th>
                            <!-- /ko -->
                        </tr> 
                    </thead>
                    <tbody>
                        
                        <!-- ko foreach: reportData -->
                        <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                            <!-- ko foreach: $parent.dynamicHeadersList -->
                                <!-- ko if: ($parentContext.$index() === 0 || $parents[1].reportData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                    <!-- ko if: $parentContext.$index() === $parents[1].reportData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].reportData()[$parentContext.$index() + 1][backendName] != $parent[backendName]-->
                                        <td class="group single"><span class="no-wrap" data-bind="text: $parent[backendName] ? $parent[backendName] : 'N/A'"></span></td>
                                    <!-- /ko -->
                                    <!-- ko ifnot: $parentContext.$index() === $parents[1].reportData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].reportData()[$parentContext.$index() +1][backendName] != $parent[backendName]-->
                                        <td class="group first"><span data-bind="text: $parent[backendName] ? $parent[backendName] : 'N/A'"></span></td>
                                    <!-- /ko -->
                                <!-- /ko --> 
                                <!-- ko ifnot: ($parentContext.$index() === 0 || $parents[1].reportData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                    <td class="group"><span></span></td>
                                <!-- /ko --> 
                            <!-- /ko --> 
                            
                            <!-- Article -->
                            <td class="colgroup-1 start">
                                <span>
                                    <span data-bind="text: Number(articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                    <!-- ko if: aaLink -->
                                            <a class="icon i-ext-link truncated-title" data-bind="attr: {href: aaLink, title: 'View in New Article Analysis'}" target="_blank"></a>
                                    <!-- /ko --> 
                                </span>
                            </td>
                            <td class="colgroup-1"><span data-bind="text: Number(activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>

                            <!-- ko if: $parent.financialPermissions() -->
                                <td class="colgroup-1"><span data-bind="text: '$' + Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-1"><span data-bind="text: '$' + Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.financialPermissions() -->
                                <td class="colgroup-1"><span data-bind="text: '$' + Number(cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.financialPermissions() -->
                                <td class="colgroup-1"><span data-bind="text: '$' + Number(revenuePerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() && $parent.costBreakdownPermissions() -->
                                <td class="colgroup-1 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'" class=""><span data-bind="text: '$' + Number(writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-1 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'" class=""><span data-bind="text: '$' + Number(editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-1 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'" class=""><span data-bind="text: '$' + Number(otherContentCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() -->
                            <td class="colgroup-1"><span data-bind="text: '$' + Number(costPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="colgroup-1"><span data-bind="text: '$' + Number(grossProfitPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- Engagement: AVD, Sign-up, Activity (Sentinel-only); Req./Sess., Imp./Sess. -->
                            <td class="colgroup-2 start"><span data-bind="text: averageViewDuration === null ? 'N/A' : Number(averageViewDuration).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- Sentinel ratios are stored as percent (×100); show % in grid for readability. -->
                            <td class="colgroup-2"><span data-bind="text: signUpRatio === null ? 'N/A' : Number(signUpRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="colgroup-2"><span data-bind="text: activityRatio === null ? 'N/A' : Number(activityRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="colgroup-2"><span data-bind="text: Number(requestsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="colgroup-2"><span data-bind="text: Number(impressionsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>

                            <!-- Overview -->
                            <td class="colgroup-4 start"><span data-bind="text: Number(activeSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td class="colgroup-4" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: Number(usActiveSessionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%'"></span></td>

                            <!-- ko if: $parent.financialPermissions() -->
                                <td class="colgroup-4" class=""><span data-bind="text: '$' + Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() -->
                                <td class="colgroup-4" class=""><span data-bind="text: '$' + Number(totalCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() -->
                                <td class="colgroup-4"><span data-bind="text: '$' + Number(costPerMilSessions).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() && $parent.financialPermissions() -->
                                <td class="colgroup-4"><span data-bind="text: Number(roi).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%',attr: { class: Number(roi) < 0 ? 'negative' : '' }"></span></td>
                            <!-- /ko -->
                        </tr>
                        <!-- /ko -->
                        
                        <!-- ko foreach: reportTotalsData -->
                        <tr class="total"data-bind="event: { click: $parent.onClickRowClick.bind($data, 'total' + $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf('total' + $index()) !== -1}">
                            <!-- ko foreach: $parent.dynamicHeadersList -->
                                <!-- ko if: ($parentContext.$index() === 0 || $parents[1].reportData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                    <!-- ko if: $parentContext.$index() === $parents[1].reportData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].reportData()[$parentContext.$index() + 1][backendName] != $parent[backendName]-->
                                        <td class=""><span class="no-wrap" data-bind="text: $parent[backendName] ? $parent[backendName] : 'N/A'"></span></td>
                                    <!-- /ko -->
                                    <!-- ko ifnot: $parentContext.$index() === $parents[1].reportData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].reportData()[$parentContext.$index() +1][backendName] != $parent[backendName]-->
                                        <td class=""><span data-bind="text: $parent[backendName] ? $parent[backendName] : 'N/A'"></span></td>
                                    <!-- /ko -->
                                <!-- /ko --> 
                                <!-- ko ifnot: ($parentContext.$index() === 0 || $parents[1].reportData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                    <td class=""><span></span></td>
                                <!-- /ko --> 
                            <!-- /ko --> 
                            
                            <!-- Article -->
                            <td class="colgroup-1 start">
                                <span>
                                    <span data-bind="text: Number(articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                    <!-- ko if: aaLink -->
                                            <a class="icon i-ext-link truncated-title" data-bind="attr: {href: aaLink, title: 'View in New Article Analysis'}" target="_blank"></a>
                                    <!-- /ko --> 
                                </span>
                            </td>
                            <td class="colgroup-1"><span data-bind="text: Number(activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>

                            <!-- ko if: $parent.financialPermissions() -->
                                <td class="colgroup-1"><span data-bind="text: '$' + Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-1"><span data-bind="text: '$' + Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.financialPermissions() -->
                                <td class="colgroup-1"><span data-bind="text: '$' + Number(cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.financialPermissions() -->
                                <td class="colgroup-1"><span data-bind="text: '$' + Number(revenuePerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() && $parent.costBreakdownPermissions() -->
                                <td class="colgroup-1 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'" class=""><span data-bind="text: '$' + Number(writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-1 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'" class=""><span data-bind="text: '$' + Number(editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                <td class="colgroup-1 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'" class=""><span data-bind="text: '$' + Number(otherContentCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() -->
                            <td class="colgroup-1"><span data-bind="text: '$' + Number(costPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="colgroup-1"><span data-bind="text: '$' + Number(grossProfitPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- Engagement totals: AVD, Sign-up, Activity (N/A in GA4); Req./Sess., Imp./Sess. -->
                            <td class="colgroup-2 start"><span data-bind="text: averageViewDuration === null ? 'N/A' : Number(averageViewDuration).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="colgroup-2"><span data-bind="text: signUpRatio === null ? 'N/A' : Number(signUpRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="colgroup-2"><span data-bind="text: activityRatio === null ? 'N/A' : Number(activityRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="colgroup-2"><span data-bind="text: Number(requestsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="colgroup-2"><span data-bind="text: Number(impressionsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>

                            <!-- Overview -->
                            <td class="colgroup-4 start"><span data-bind="text: Number(activeSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td class="colgroup-4" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: Number(usActiveSessionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%'"></span></td>

                            <!-- ko if: $parent.financialPermissions() -->
                                <td class="colgroup-4" class=""><span data-bind="text: '$' + Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() -->
                                <td class="colgroup-4" class=""><span data-bind="text: '$' + Number(totalCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() -->
                                <td class="colgroup-4"><span data-bind="text: '$' + Number(costPerMilSessions).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.costPermissions() && $parent.financialPermissions() -->
                                <td class="colgroup-4"><span data-bind="text: Number(roi).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%',attr: { class: Number(roi) < 0 ? 'negative' : '' }"></span></td>
                            <!-- /ko -->
                        </tr>
                        <!-- /ko -->
                    </tbody>
                </table>
            </div>
        `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('contentInvestment');

        this.dimensionGrouping = new multipleSelector_template("dimensionGrouping", this.getTemplateViewModel(), this.caller);
        this.dimensionGrouping.setLabel("Dimensions");
        this.dimensionGrouping.setFilterContainerClass('margin-neg');
        this.dimensionGrouping.setTagContainerId('selected-dimensions');
        this.dimensionGrouping.setTagContainerCaption('Selected dimensions:');
        this.dimensionGrouping.setItems(contentInvestment_template.dimensionGroupingItems);
        this.dimensionGrouping.setSelectAllEnabled(false);
        this.dimensionGrouping.setDisplaySelectionOrder(true);

        // In order for preset filters to work with this report, we must make sure to not overwrite the dimensionGrouping if it's already set in the URL
        if (window.location.href.search(/dimensionGrouping/gi) == -1){

            this.dimensionGrouping.getTemplateViewModel().selectedItems(["idBrand"]);
            this.dimensionGrouping.setSelectedItemsOrderBySelection([{"id":"idBrand"}]);
            this.getTemplateViewModel().groupingDimensionsSelected.push({ "id": "idBrand",  "name": "Brand", "backendName": "brand", "displayName" : "brandShortName"});
        }

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setLogoEnabled(true);

        this.brandSegmentsFilter = new multipleSelector_template("brandSegmentsFilter", this.getTemplateViewModel(), this.caller);
        this.brandSegmentsFilter.setTagContainerId('selected-brand-segments');
        this.brandSegmentsFilter.setTagContainerCaption('Selected segments:');
        this.brandSegmentsFilter.setLabel("segments");
        this.brandSegmentsFilter.setLogoEnabled(false);

        this.postInitiativesFilter = new multipleSelector_template("postInitiativesFilter", this.getTemplateViewModel(), this.caller);
        this.postInitiativesFilter.setLabel("Mappings");
        this.postInitiativesFilter.setFilterContainerClass('margin-neg');
        this.postInitiativesFilter.setTagContainerId('selected-initiatives');
        this.postInitiativesFilter.setTagContainerCaption('Selected mappings:');

        this.postPaymentCategorySystemFilter = new multipleSelector_template("postPaymentCategorySystemFilter", this.getTemplateViewModel(), this.caller);
        this.postPaymentCategorySystemFilter.setLabel("System");
        this.postPaymentCategorySystemFilter.setFilterContainerClass('margin-neg');
        this.postPaymentCategorySystemFilter.setTagContainerId('selected-systems');
        this.postPaymentCategorySystemFilter.setTagContainerCaption('Selected systems:');

        this.postIntentsFilter = new multipleSelector_template("postIntentsFilter", this.getTemplateViewModel(), this.caller);
        this.postIntentsFilter.setLabel("Intents");
        this.postIntentsFilter.setFilterContainerClass('margin-neg');
        this.postIntentsFilter.setTagContainerId('selected-intents');
        this.postIntentsFilter.setTagContainerCaption('Selected intents:');

        this.postContentTypesFilter = new multipleSelector_template("postContentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.postContentTypesFilter.setLabel("content types");
        this.postContentTypesFilter.setTagContainerId('selected-content_types');
        this.postContentTypesFilter.setTagContainerCaption('Selected content types:');

        this.articleTypesFilter = new multipleSelector_template("articleTypesFilter", this.getTemplateViewModel(), this.caller);
        this.articleTypesFilter.setLabel("page types");
        this.articleTypesFilter.setTagContainerId('selected-article_types');
        this.articleTypesFilter.setTagContainerCaption('Selected page types:');

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.primaryCategoriesFilter = new filterMultipleAutoComplete_template("primaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoriesFilter.setIsVisible(1);
        this.primaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoriesFilter.setIcon("i-tag-a");
        this.primaryCategoriesFilter.setTagContainerId('selected-primary_categories');
        this.primaryCategoriesFilter.setTagContainerCaption('Selected Primary Categories:');
        this.primaryCategoriesFilter.setMinInputSuggestionLength(2);

        this.srEditorsFilter = new filterMultipleAutoComplete_template("srEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.srEditorsFilter.setIsVisible(1);
        this.srEditorsFilter.setPlaceHolderText("Sr Editor");
        this.srEditorsFilter.setIcon("i-user2");
        this.srEditorsFilter.setTagContainerId('selected-sr-editors');
        this.srEditorsFilter.setTagContainerCaption('Selected Sr Editors:');
        this.srEditorsFilter.setMinInputSuggestionLength(2);

        this.jrEditorsFilter = new filterMultipleAutoComplete_template("jrEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.jrEditorsFilter.setIsVisible(1);
        this.jrEditorsFilter.setPlaceHolderText("Jr Editor");
        this.jrEditorsFilter.setIcon("i-user2");
        this.jrEditorsFilter.setTagContainerId('selected-jr-editors');
        this.jrEditorsFilter.setTagContainerCaption('Selected Jr Editors:');
        this.jrEditorsFilter.setMinInputSuggestionLength(2);

        this.brandSafetyFilter = new multipleSelector_template("brandSafetyFilter", this.getTemplateViewModel(), this.caller);
        this.brandSafetyFilter.setLabel("Brand Safety");
        this.brandSafetyFilter.setFilterContainerClass('margin-neg');
        this.brandSafetyFilter.setTagContainerId('selected-brandSafety');
        this.brandSafetyFilter.setTagContainerCaption('Selected brand safety:');


        this.initializeToolTips();

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        let mm = date.getMonth() + 1;

        // if it is the first day of the quarter, we display data from the last quarter
        if (date.getDate() == 1){

            if (mm == 1){

                mm = 12;
            } else if (mm == 4 || mm == 7 || mm == 10){

                mm = mm - 1;
            }
        }

        let monthIndex;
        if (mm >= 1 && mm <= 3){

            monthIndex = 0;
        }else if(mm >= 4 && mm <= 6){

            monthIndex = 3
        }else if(mm >= 7 && mm <= 9){

            monthIndex = 6
        }else{

            monthIndex = 9
        }

        date.setDate(date.getDate() - 1);

        let startDate = new Date(date.getFullYear(), monthIndex, 1);;
        this.datesFilter.setDateRange(startDate, date);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.exportReportDataCsv = new exportDataCsv();
    }

    protected initializeToolTips(): void {

        if (this.toolTipActiveSessions === undefined){

            this.toolTipActiveSessions = new infoButton_template('toolTipActiveSessions', this.getTemplateViewModel(), this.caller)
            this.toolTipActiveSessions.setTitle('Active Sessions');
        }

        let toolTipActiveSessionsContent = "<p>Total sessions for articles published in the chosen date range within the first " + this.getTemplateViewModel().dataRangeSelected() + " days of being published.</p>";
        toolTipActiveSessionsContent = toolTipActiveSessionsContent + "<p>Data for each day will continue to accumulate daily up until " + this.getTemplateViewModel().dataRangeSelected() + " days.</p>";
        this.toolTipActiveSessions.setContent(toolTipActiveSessionsContent);

        if (this.toolTipTotalRevenue === undefined){

            this.toolTipTotalRevenue = new infoButton_template('toolTipTotalRevenue', this.getTemplateViewModel(), this.caller)
            this.toolTipTotalRevenue.setTitle('Active Revenue');
        }

        let toolTipTotalRevenueContent = "<p>Total revenue generated by active sessions on articles published within the selected date range during their first " + this.getTemplateViewModel().dataRangeSelected() + " days of being published.</p>";
        toolTipTotalRevenueContent = toolTipTotalRevenueContent + "<p>Data for each day will continue to accumulate daily up until " + this.getTemplateViewModel().dataRangeSelected() + " days.</p>";
        this.toolTipTotalRevenue.setContent(toolTipTotalRevenueContent);

        if (this.toolTipROI === undefined){

            let toolTipROIContent = "<p>Calculated as (Total Revenue - Total Cost) / (Total Cost) * 100</p>";
            this.toolTipROI = new infoButton_template('toolTipROI', this.getTemplateViewModel(), this.caller)
            this.toolTipROI.setTitle('ROI%');
            this.toolTipROI.setContent(toolTipROIContent);
        }

        // Sentinel traffic: sign-up ratio is a percent using non-logged pageviews (views minus logged-in) as denominator.
        if (this.toolTipSignUpRatio === undefined) {
            this.toolTipSignUpRatio = new infoButton_template('toolTipSignUpRatio', this.getTemplateViewModel(), this.caller);
            this.toolTipSignUpRatio.setTitle('Sign-up Ratio');
            this.toolTipSignUpRatio.setContent('<p>Sign-up Ratio = (new accounts / non-logged-in pageviews) × 100, shown as a percentage.</p>');
        }

        // Activity ratio denominator is total Sentinel pageviews (all views), not non-logged-only.
        if (this.toolTipActivityRatio === undefined) {
            this.toolTipActivityRatio = new infoButton_template('toolTipActivityRatio', this.getTemplateViewModel(), this.caller);
            this.toolTipActivityRatio.setTitle('Activity Ratio');
            let toolTipActivityRatioContent = `
                <p>Activity Ratio = (Activity events / Active pageviews) × 100, shown as a percentage.</p></br>

                <p><i>Sentinel Activity events (Article-level) :</i> </p>
                <ul>
                    <li><i>Internal Link Clicks</i></li>
                    <li><i>All Sentinel Click Interactions events</i></li>
                    <li><i>Quiz Widget events : Start Quiz</i></li>
                </ul></br>

                <p><i>Emaki Activity events (Article-level) :</i> </p>
                <ul>
                    <li><i>Comments, replies, mentions and comment votes</i></li>
                    <li><i>Pinned comments and suggested threads</i></li>
                    <li><i>Reviews, review votes and ratings</i></li>
                    <li><i>Article follows and article likes</i></li>
                </ul>
            `;

            this.toolTipActivityRatio.setContent(toolTipActivityRatioContent);
        }
    }

    protected getTemplateName(): string{

        return "contentInvestment_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }


    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            orderBy                     : ko.observable("Revenue"),
            orderByDirection            : ko.observable("DESC"),
            orderByAndDirection         : ko.observable("revenue_DESC"),
            reportData                  : ko.observableArray([]),
            reportTotalsData            : ko.observableArray([]),
            groupingDimensionsSelected  : ko.observableArray([]),
            formOptions                 : ko.observableArray([]),
            formOptionSelected          : ko.observable("all"),
            dataRanges                  : ko.observableArray([]),
            dataRangeSelected           : ko.observable(30),
            dynamicHeadersList          : ko.observableArray([]),
            costPermissions             : ko.observable(0),
            financialPermissions        : ko.observable(0),
            costBreakdownPermissions    : ko.observable(0),
            reconciliationPermissions   : ko.observable(0),
            reconciliationData       : ko.observableArray([]),
            exportDataButtonClickable    : ko.observable(1),
            reconciliationDataButtonClickable    : ko.observable(1),
            articleSectionColumnCount   : ko.observable(1),
            engagementSectionColumnCount: ko.observable(5),
            overviewSectionColumnCount  : ko.observable(1),
            collapseButtonHidden        : ko.observable(1),
            collapseButtonClass         : ko.observable("i-expand"),
            collapseButtonText          : ko.observable("expand"),
            exportButtonHidden          : ko.observable(1),
            exportReconciliationButtonHidden    : ko.observable(0),
            trafficSource               : ko.observable(2),
            selectedRows                : ko.observableArray([]),
            publishStatus               : ko.observableArray([]),
            publishStatusSelected       : ko.observable("all"),
            onFormOptionChange          : function(data) {huit_neuf_this.onFormOptionChange(data); },
            onDataRangeChange           : function(data) {huit_neuf_this.onDataRangeChange(data); },
            onCollapseClick             : function(){ huit_neuf_this.onCollapseClick(); },
            onClickReorder              : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); },
            exportData                  : function(){ huit_neuf_this.exportData(); },
            exportReconciliationData    : function(){ huit_neuf_this.exportReconciliationData(huit_neuf_this); },
            onToggleTrafficSource       : function(data, event){ huit_neuf_this.onToggleTrafficSource(data, event);},
            onClickRowClick             : function(index, data){ huit_neuf_this.onClickRowClick(index); return true; },
            onPublishStatusChange       : function(data){ huit_neuf_this.onPublishStatusChange(); },
        };
    }

    public onToggleTrafficSource(data, event){

        let toggleValue = this.getTemplateViewModel().trafficSource();

        if (toggleValue == 2) {

            this.getTemplateViewModel().trafficSource(1); // GA4 = 1
        }else {

            this.getTemplateViewModel().trafficSource(2); // Sentinel = 2
        }

        this.caller.getListData();
    }

    public getViewModelForRequest(){

        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection(),
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            brandSegments: this.getTemplateViewModel().brandSegmentsFilter.selectedItems(),
            postInitiatives: this.getTemplateViewModel().postInitiativesFilter.selectedItems(),
            postPaymentCategorySystems: this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems(),
            postIntents: this.getTemplateViewModel().postIntentsFilter.selectedItems(),
            postContentTypes: this.getTemplateViewModel().postContentTypesFilter.selectedItems(),
            articleTypes: this.getTemplateViewModel().articleTypesFilter.selectedItems(),
            networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
            idPrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds(),
            namePrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames(),
            srEditors: this.getTemplateViewModel().srEditorsFilter.selectedItemIds(),
            srEditorNames: this.getTemplateViewModel().srEditorsFilter.selectedItemNames(),
            jrEditors: this.getTemplateViewModel().jrEditorsFilter.selectedItemIds(),
            jrEditorNames: this.getTemplateViewModel().jrEditorsFilter.selectedItemNames(),
            dimensionGroupings: this.getTemplateViewModel().groupingDimensionsSelected(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            postContentTypesGroup: this.getTemplateViewModel().formOptionSelected(),
            dataRange: this.getTemplateViewModel().dataRangeSelected(),
            trafficSource: this.getTemplateViewModel().trafficSource(),
            publishStatus: this.getTemplateViewModel().publishStatusSelected(),
            brandSafetyTypes: this.getTemplateViewModel().brandSafetyFilter.selectedItems(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        return super.build(classesToAdd);
    }

    public buildDatePickerCalendar(){

        this.datesFilter.buildCalendar();
    }

    public initiateDimensionSelectTag(){

        this.dimensionGrouping.setTags(["idBrand"], contentInvestment_template.dimensionGroupingItems);
    }

    public setPublishStatusItems(){

        this.getTemplateViewModel().publishStatus(this.publishStatus);
    }

    public setBrandSafetyFilterItems(){

        this.brandSafetyFilter.setItems(this.brandSafety);
    }

    public setBrandFilterItems(departments){

        let groups = [];
        for ( let department of departments){

            let brands = [];
            for( let brand of department.brands){

                if(brand.segments.length > 0){

                    for(let segment of brand.segments){

                        brands.push(segment);
                    }
                }
                else{

                    brands.push(brand);
                }
            }

            let group = {"name" : department.name, "logo" : department.logo, "items" : brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }

    public setBrandSegments(brandSegments){

        let groups = [];
        for (let brand of brandSegments){

            let segments = [];
            for( let segment of brand.segments){

                segments.push(segment);
            }

            let group = {"name" : brand.name, "items" : segments};
            groups.push(group);
        }
        this.brandSegmentsFilter.setMultiSectionItems(groups);
        this.brandSegmentsFilter.setLabel('Segments');
    }

    public setPostInitiativesFilterItems(items){

        for (let item of items){

            item['name'] = item['initiative'];
        }
        items.unshift({'id': 0, 'name' : 'no mappings'});
        this.postInitiativesFilter.setItems(items);
    }

    public setPostPaymentCategorySystemFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no systems'});
        this.postPaymentCategorySystemFilter.setItems(items);
    }


    public setPostIntentsFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.postIntentsFilter.setItems(items);
    }

    public setPostContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.postContentTypesFilter.setMultiSectionItems(groups);
        this.postContentTypesFilter.setLabel('Content Types');
    }

    //public setArticleTypesFilterItems(items){
    public setArticleTypesFilterItems(){

        //this.articleTypesFilter.setItems(items);
        this.articleTypesFilter.setItems(this.articleTypes);
        this.articleTypesFilter.setSelectedItems([{id: 'Regular'}]);
        this.articleTypesFilter.setTags(['Regular'], this.articleTypesFilter.getItems());
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoriesFilter.setMultiSectionItems(groups);
        this.networkCategoriesFilter.setLabel('Network Categories');
    }

    private encodeValue(paramValue){

        if(paramValue == null){

            return false;
        }

        if(Array.isArray(paramValue)){
            if(paramValue.length == 0){
                return false;
            }

            paramValue = JSON.stringify(paramValue);
            paramValue = encodeURIComponent(paramValue);
        }

        if(typeof paramValue === 'object'){

            paramValue = JSON.stringify(paramValue);
            paramValue = encodeURIComponent(paramValue);
        }

        if(typeof paramValue === 'function'){

            let functionValue = paramValue();
            if(functionValue){
                paramValue = JSON.stringify(functionValue);
                paramValue = encodeURIComponent(functionValue);
            }else{
                return false;
            }
        }

        return paramValue;
    }

    private encodeIds(ids){

        let intIds = [];

        for(let id of ids){

            intIds.push(parseInt(id));
        }

        return encodeURIComponent('[' + intIds.join(',') + ']');
    }

    public getAALinkBaseParams() {
        let aaLinkParams = [];

        if(this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems() !== null && this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems().length > 0){
            
            aaLinkParams['postPaymentCategorySystems'] = this.encodeValue(this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems());
        }

        if(this.getTemplateViewModel().postInitiativesFilter.selectedItems() !== null && this.getTemplateViewModel().postInitiativesFilter.selectedItems().length > 0){
            
            aaLinkParams['postInitiatives'] = this.encodeValue(this.getTemplateViewModel().postInitiativesFilter.selectedItems());
        }

        if(this.getTemplateViewModel().brandSafetyFilter.selectedItems() !== null && this.getTemplateViewModel().brandSafetyFilter.selectedItems().length > 0){
            
            aaLinkParams['brandSafetyTypes'] = this.encodeValue(this.getTemplateViewModel().brandSafetyFilter.selectedItems());
        }
        
        if(this.getTemplateViewModel().datesFilter.startDate()){

            aaLinkParams['startDate'] = this.encodeValue(this.getTemplateViewModel().datesFilter.startDate());
        }

        if(this.getTemplateViewModel().datesFilter.endDate()){

            aaLinkParams['endDate'] = this.encodeValue(this.getTemplateViewModel().datesFilter.endDate());
        }

        if(this.getTemplateViewModel().brandsFilter.selectedItems() !== null && this.getTemplateViewModel().brandsFilter.selectedItems().length > 0){

            aaLinkParams['brands'] = this.encodeIds(this.getTemplateViewModel().brandsFilter.selectedItems());
        }

        if(this.getTemplateViewModel().brandSegmentsFilter.selectedItems() !== null && this.getTemplateViewModel().brandSegmentsFilter.selectedItems().length > 0){

            aaLinkParams['brandSegments'] = this.encodeValue(this.getTemplateViewModel().brandSegmentsFilter.selectedItems());
        }

        if(this.getTemplateViewModel().postIntentsFilter.selectedItems() !== null && this.getTemplateViewModel().postIntentsFilter.selectedItems().length > 0){

            aaLinkParams['postIntents'] = this.encodeValue(this.getTemplateViewModel().postIntentsFilter.selectedItems());
        }

        if(this.getTemplateViewModel().postContentTypesFilter.selectedItems() !== null && this.getTemplateViewModel().postContentTypesFilter.selectedItems().length > 0){

            aaLinkParams['postContentTypes'] = this.encodeValue(this.getTemplateViewModel().postContentTypesFilter.selectedItems());
        }

        if(this.getTemplateViewModel().networkCategoriesFilter.selectedItems() !== null && this.getTemplateViewModel().networkCategoriesFilter.selectedItems().length > 0){

            aaLinkParams['networkCategories'] = this.encodeValue(this.getTemplateViewModel().networkCategoriesFilter.selectedItems());
        }

        if(this.getTemplateViewModel().srEditorsFilter.selectedItems() !== null && this.getTemplateViewModel().srEditorsFilter.selectedItems().length > 0){

            aaLinkParams['srEditors'] = this.encodeValue(this.getTemplateViewModel().srEditorsFilter.selectedItemIds());
            aaLinkParams['srEditorNames'] = this.encodeValue(this.getTemplateViewModel().srEditorsFilter.selectedItemNames());
        }

        if(this.getTemplateViewModel().jrEditorsFilter.selectedItems() !== null && this.getTemplateViewModel().jrEditorsFilter.selectedItems().length > 0){

            aaLinkParams['jrEditors'] = this.encodeValue(this.getTemplateViewModel().jrEditorsFilter.selectedItemIds());
            aaLinkParams['jrEditorNames'] = this.encodeValue(this.getTemplateViewModel().jrEditorsFilter.selectedItemNames());
        }

        if (this.getTemplateViewModel().publishStatusSelected()){

            aaLinkParams['publishStatus'] = encodeURIComponent(this.getTemplateViewModel().publishStatusSelected());
        }

        if (this.getTemplateViewModel().trafficSource()){

            aaLinkParams['trafficSource'] = encodeURIComponent(this.getTemplateViewModel().trafficSource());
        }

        if(this.getTemplateViewModel().formOptionSelected()){

            aaLinkParams['postContentTypesGroup'] = encodeURIComponent(this.getTemplateViewModel().formOptionSelected());
        }

        if(this.getTemplateViewModel().articleTypesFilter.selectedItems() !== null && this.getTemplateViewModel().articleTypesFilter.selectedItems().length > 0){

            // not an array in aa, so we take the first element
            for (let articleType of this.getTemplateViewModel().articleTypesFilter.selectedItems()){

                aaLinkParams['articleType'] = articleType.toLowerCase();
                break;
            }
        }

        if(this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds() !== null && this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds().length > 0){

            // not an array in aa, so we take the first element
            for (let idPrimaryCategory of this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds()){

                aaLinkParams['primaryCategory'] = encodeURIComponent(parseInt(idPrimaryCategory));
                break;
            }
        }

        if(this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames() !== null && this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames().length > 0){

            // not an array in aa, so we take the first element
            for (let namePrimaryCategory of this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames()){

                aaLinkParams['primaryCategoryName'] = encodeURIComponent(namePrimaryCategory);
                break;
            }
        }

        return aaLinkParams;
    }

    private overrideAALinkParams(params, row){

        if(typeof row['Day'] !== 'undefined' && row['Day'] !== "undefined, NaN-NaN-NaN"){

            let date = this.encodeValue(row['Day'].split(', ')[1]);

            params['startDate'] = date;
            params['endDate'] = date;
        }

        // Only override monthYear if there is no Day dimension
        if(typeof row['monthYear'] !== 'undefined' && (typeof row['Day'] === 'undefined' || row['Day'] === "undefined, NaN-NaN-NaN")){

            let year = row['monthYear'].split('-')[0];
            let month = row['monthYear'].split('-')[1];

            let firstDayOfMonth = new Date(year, month-1, 1);
            let lastDayOfMonth = new Date(year, month, 0);

            let startDate = new Date(this.getTemplateViewModel().datesFilter.startDate())
            let endDate = new Date(this.getTemplateViewModel().datesFilter.endDate())

            if (firstDayOfMonth.valueOf() > startDate.valueOf()){

                startDate = firstDayOfMonth;
            }

            if (lastDayOfMonth.valueOf() < endDate.valueOf()){

                endDate = lastDayOfMonth;
            }

            params['startDate'] = startDate.toISOString().split('T')[0];
            params['endDate'] = endDate.toISOString().split('T')[0];
        }

        if(typeof row['brand'] !== 'undefined' && typeof row['idBrand'] !== 'undefined'){

            params['brands'] = this.encodeIds([row['idBrand']]);
        }

        if(typeof row['intiative'] !== 'undefined'){

            params['postInitiatives'] = this.encodeIds([row['idInitiative']]);
        }

        if(typeof row['intent'] !== 'undefined'){

            params['postIntents'] = this.encodeIds([row['idIntent']]);
        }

        if(typeof row['content_type'] !== 'undefined'){

            params['postContentTypes'] = this.encodeIds([row['idContentType']]);
        }

        if(typeof row['articleType'] !== 'undefined'){

            params['articleType'] = row['articleType'].toLowerCase();
        }

        if(typeof row['primary_category'] !== 'undefined'){

            params['primaryCategory'] = encodeURIComponent(parseInt(row['idPrimaryCategory']));
            params['primaryCategoryName'] = encodeURIComponent(row['primary_category']);
        }

        if(typeof row['idEditor'] !== 'undefined'){

            if (row['idEditor'] === null){

                params['srEditors'] = this.encodeIds([0]);
            } else{

                params['srEditors'] = this.encodeIds([parseInt(row['idEditor'])]);
            }
        }

        if(typeof row['sr_editor'] !== 'undefined'){

            if (row['sr_editor'] === null){

                params['srEditorNames'] = this.encodeValue(["null"]);
            }else{

                params['srEditorNames'] = this.encodeValue([row['sr_editor']]);
            }
        }

        if(typeof row['idJrEditor'] !== 'undefined'){

            if (row['idJrEditor'] === null){

                params['jrEditors'] = this.encodeIds([0]);
            } else{

                params['jrEditors'] = this.encodeIds([parseInt(row['idJrEditor'])]);
            }
        }

        if(typeof row['jr_editor'] !== 'undefined'){

            if (row['jr_editor'] === null){

                params['jrEditorNames'] = this.encodeValue(["null"]);
            }else{

                params['jrEditorNames'] = this.encodeValue([row['jr_editor']]);
            }
        }

        return params;
    }

    public getAAlink(params){

        let aaLink = 'https://pubinsights.com/article_analysis?viewMode=article&orderBy=revenue&orderByDirection=DESC&orderByAndDirection=revenue_DESC';

        for (const key in params){

            const indexedItem = params[key];
            aaLink = aaLink + '&' + key + '=' + indexedItem;
        }

        return aaLink;
    }

    public setReportData(reportData){

        this.setDynamicHeaders();
        this.showExportButton();
        this.showExportReconciliationButton();

        let groupings = [];
        let aaBaseParams = this.getAALinkBaseParams();
        for (let reportDataPerDimensionGrouping of reportData.reportDataPerDimensionGroupings){

            reportDataPerDimensionGrouping['aaLink'] = this.getAAlink(this.overrideAALinkParams(aaBaseParams, reportDataPerDimensionGrouping));
            groupings.push(reportDataPerDimensionGrouping);
        }
        this.getTemplateViewModel().reportData(groupings);

        let reportTotalsData = [];
        reportData.totalReportData['aaLink'] = this.getAAlink(this.getAALinkBaseParams());
        reportTotalsData.push(reportData.totalReportData);
        this.getTemplateViewModel().reportTotalsData(reportTotalsData);
    }

    public onClickReorder(value, data, event){

        if(typeof data.orderBy === 'undefined'){

            data = this.getTemplateViewModel();
        }
        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection() === null || data.orderByAndDirection().includes(value)){

            if( data.orderByDirection() == "DESC" ){

                data.orderByDirection("ASC");
            }
            else{

                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.hideExportButton();
        this.caller.listReorder();
    }

    public validateOrderBy(){

        let orderByChoosen = this.getTemplateViewModel().orderBy();

        // @ts-ignore
        let orderByIsDimension = contentInvestment_template.dimensionGroupingItems.find(i => i.backendName === orderByChoosen);

        if(orderByIsDimension != null){

            let orderByInSelectedDimension = this.getTemplateViewModel().groupingDimensionsSelected().find(i => i.backendName === orderByChoosen);

            if(typeof orderByInSelectedDimension === 'undefined'){

                this.getTemplateViewModel().orderBy(null);
                this.getTemplateViewModel().orderByAndDirection(null);
            }
        }
    }

    private setDynamicHeaders() {

        this.getTemplateViewModel().dynamicHeadersList([]);

        for (let selectedDimensionItem of this.getTemplateViewModel().dimensionGrouping.selectedItemsOrderBySelection()) {

            for (let dimensionItem of contentInvestment_template.dimensionGroupingItems) {

                if (selectedDimensionItem === dimensionItem.id) {

                    this.getTemplateViewModel().dynamicHeadersList.push(dimensionItem);
                }
            }
        }
    }

    public resetDefaultDimensionFilters(){

        if(this.getTemplateViewModel().dimensionGrouping.selectedItems().length === 0){

            this.dimensionGrouping.getTemplateViewModel().selectedItems(["idBrand"]);
            this.dimensionGrouping.setSelectedItemsOrderBySelection([{"id":"idBrand"}]);
        }
    }

    public setSelectDimensionsObjects(){

        let previousSelections = this.getTemplateViewModel().groupingDimensionsSelected();

        // We need to keep track of the date field selected to adjust the sorting accordingly
        let previousDateFieldSelected = '';
        for (let previousSelection of previousSelections) {

            if (previousSelection.id === "dateData" || (previousDateFieldSelected == '' && previousSelection.id === "monthYear")) {

                previousDateFieldSelected = previousSelection.id;
            }
        }

        this.getTemplateViewModel().groupingDimensionsSelected([]);

        let newDateDateFieldSelected = '';
        for (let selectedDimensionItem of this.getTemplateViewModel().dimensionGrouping.selectedItemsOrderBySelection()) {

            for (let dimensionItem of contentInvestment_template.dimensionGroupingItems) {

                if (selectedDimensionItem === dimensionItem.id) {

                    this.getTemplateViewModel().groupingDimensionsSelected.push(dimensionItem);

                    if (dimensionItem.id === "dateData" || (newDateDateFieldSelected == '' && dimensionItem.id === "monthYear")) {

                        newDateDateFieldSelected = dimensionItem.id;
                    }
                }
            }
        }

        if ((previousDateFieldSelected == '' && newDateDateFieldSelected != '') || (previousDateFieldSelected == 'monthYear' && newDateDateFieldSelected == 'dateData')) {
            
            // We want to sort by date when possible
            this.getTemplateViewModel().orderBy(newDateDateFieldSelected);
            this.getTemplateViewModel().orderByDirection("ASC");
            this.getTemplateViewModel().orderByAndDirection(newDateDateFieldSelected + "_" + this.getTemplateViewModel().orderByDirection());
            this.caller.listReorder();
        } else if (previousDateFieldSelected != '' && newDateDateFieldSelected == '') {
            
            // When unselecting date dimension, reset back to default revenue sort.
            this.getTemplateViewModel().orderBy("Revenue");
            this.getTemplateViewModel().orderByDirection("DESC");
            this.getTemplateViewModel().orderByAndDirection("Revenue" + "_" + this.getTemplateViewModel().orderByDirection());
            this.caller.listReorder();
        }
    }

    public setPostContentTypesGroupFilterItems(){

        this.getTemplateViewModel().formOptions(this.contentTypesGroup);
    }

    private exportData(){

        let check = this.getTemplateViewModel().exportDataButtonClickable();
        if (check) {

            this.getTemplateViewModel().exportDataButtonClickable(0);
            this.caller.getCsvExportData();
        }
    }

    private setExportData(reportData){

        let exportDataView = [];
        for (let exportDataRow of reportData.reportDataPerDimensionGroupings) {

            let exportDataViewRow = this.getFormatedExportRow(exportDataRow);
            exportDataView.push(exportDataViewRow);
        }

        let exportDataViewRow = this.getFormatedExportRow(reportData.totalReportData);
        exportDataView.push(exportDataViewRow);

        let fileName = "contentInvestment_data_from_" + this.datesFilter.getTemplateViewModel().startDate() + "_to_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportReportDataCsv.exportToCsv(fileName, exportDataView);

        this.getTemplateViewModel().exportDataButtonClickable(1);
    }

    private exportReconciliationData(obj){

        let check = this.getTemplateViewModel().reconciliationDataButtonClickable();
        if (check) {

            this.getTemplateViewModel().reconciliationDataButtonClickable(0);
            this.caller.getCsvReconciliationData();
        }
    }

    private setExportReconciliationData(data){

        this.getTemplateViewModel().reconciliationData(data);

        let fileName = "contentInvestment_Cost_Reconciliation_from_" + this.datesFilter.getTemplateViewModel().startDate() + "_to_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportReportDataCsv.exportToCsv(fileName, this.getTemplateViewModel().reconciliationData());
        this.getTemplateViewModel().reconciliationDataButtonClickable(1);

    }

    private getFormatedExportRow(exportDataRow) {

        let exportDataViewRow = [];

        for (let dynamicHeadersList of this.getTemplateViewModel().groupingDimensionsSelected()) {

            exportDataViewRow[dynamicHeadersList.name] = exportDataRow[dynamicHeadersList.backendName];
        }

        // Article section
        exportDataViewRow["Art."] = Number(exportDataRow.articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Act. Sess./Art."] = Number(exportDataRow.activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

        if (this.getTemplateViewModel().financialPermissions()) {

            exportDataViewRow["SV"] = '$' + Number(exportDataRow.sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["RPM"] = '$' + Number(exportDataRow.rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (this.getTemplateViewModel().financialPermissions()) {

            exportDataViewRow["CPM"] = '$' + Number(exportDataRow.cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (this.getTemplateViewModel().financialPermissions()) {

            exportDataViewRow["Rev./Art."] = '$' + Number(exportDataRow.revenuePerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (this.getTemplateViewModel().costPermissions() && this.getTemplateViewModel().costBreakdownPermissions()) {

            exportDataViewRow["Writer Cost"] = '$' + Number(exportDataRow.writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Editor Cost"] = '$' + Number(exportDataRow.editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Other Content Cost"] = '$' + Number(exportDataRow.otherContentCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (this.getTemplateViewModel().costPermissions()) {

            exportDataViewRow["C/A"] = '$' + Number(exportDataRow.costPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["GP/A"] = '$' + Number(exportDataRow.grossProfitPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        exportDataViewRow["Act. Sess."] = Number(exportDataRow.activeSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});

        // Engagement section
        exportDataViewRow["Average View Duration (S)"] = (exportDataRow.averageViewDuration === null) ? "N/A" : Number(exportDataRow.averageViewDuration).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Sign-up Ratio"] = (exportDataRow.signUpRatio === null) ? "N/A" : Number(exportDataRow.signUpRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        exportDataViewRow["Activity Ratio"] = (exportDataRow.activityRatio === null)? "N/A" : Number(exportDataRow.activityRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        exportDataViewRow["Req./Sess."] = Number(exportDataRow.requestsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Imp./Sess."] = Number(exportDataRow.impressionsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

        // Overview Section
        exportDataViewRow["US Traffic%"] = Number(exportDataRow.usActiveSessionsPercentage).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%';

        if (this.getTemplateViewModel().financialPermissions()) {

            exportDataViewRow["Act. Revenue"] = '$' + Number(exportDataRow.revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (this.getTemplateViewModel().costPermissions()) {

            exportDataViewRow["Total Cost"] = '$' + Number(exportDataRow.totalCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Cost/1k Sess."] = '$' + Number(exportDataRow.costPerMilSessions).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (this.getTemplateViewModel().costPermissions() && this.getTemplateViewModel().financialPermissions()) {

            exportDataViewRow["Act. Gross ROI%"] = Number(exportDataRow.roi).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%';
        }

        return exportDataViewRow;
    }

    public hideExportButton(){

        this.getTemplateViewModel().exportButtonHidden(1);
    }

    public showExportButton(){

        this.getTemplateViewModel().exportButtonHidden(0);
    }

    public hideExportReconciliationButton(){
        this.getTemplateViewModel().exportReconciliationButtonHidden(1);
    }

    public showExportReconciliationButton(){
        this.getTemplateViewModel().exportReconciliationButtonHidden(0);
    }

    private onCollapseClick(){

        if(this.getTemplateViewModel().collapseButtonText() == 'simplify'){

            this.getTemplateViewModel().collapseButtonClass('i-expand');
            this.getTemplateViewModel().collapseButtonText('expand');
        }else{

            this.getTemplateViewModel().collapseButtonClass('i-simplify');
            this.getTemplateViewModel().collapseButtonText('simplify');
        }

        this.calculateColumnCount();
    }

    private onFormOptionChange(selectedRevenueOption){

        this.caller.getListData();
    }

    /**
     * @inheritDoc
     */
    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.brandSegmentsFilter, params['brandSegments']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postInitiativesFilter, params['postInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postPaymentCategorySystemFilter, params['postPaymentCategorySystems']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postIntentsFilter, params['postIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postContentTypesFilter, params['postContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.articleTypesFilter, params['articleTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoriesFilter, params['networkCategories']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.primaryCategoriesFilter, params['idPrimaryCategories'], params['namePrimaryCategories']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.srEditorsFilter, params['srEditors'], params['srEditorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.jrEditorsFilter, params['jrEditors'], params['jrEditorNames']);


        if(typeof params['brandSafetyTypes'] !== 'undefined'){

            this.presetFilter.setMultiSelectorPresetFilters(this.brandSafetyFilter, params['brandSafetyTypes']);
        }

        if(typeof params['dimensionGroupings'] !== 'undefined'){

            let dimensionGroupingIds = [];

            for (let dimensionGrouping of params['dimensionGroupings']){

                dimensionGroupingIds.push(dimensionGrouping.id);
            }

            this.presetFilter.setMultiSelectorPresetFilters(this.dimensionGrouping, dimensionGroupingIds);
            this.getTemplateViewModel().groupingDimensionsSelected(params['dimensionGroupings']);
        }

        if(typeof params['dataRange'] !== 'undefined'){

            this.getTemplateViewModel().dataRangeSelected(params['dataRange'])
            this.initializeToolTips();
        }

        if(typeof params['postContentTypesGroup'] !== 'undefined') {

            this.getTemplateViewModel().formOptionSelected(params['postContentTypesGroup']);
        }

        if(typeof params['publishStatus'] !== 'undefined'){

            this.getTemplateViewModel().publishStatusSelected(params['publishStatus']);
        }

        if(typeof params['trafficSource'] !== 'undefined'){

            this.getTemplateViewModel().trafficSource(params['trafficSource']);
        }

        if(typeof params['orderBy'] !== 'undefined'){

            this.getTemplateViewModel().orderBy(params['orderBy']);
        }

        if(typeof params['orderByDirection'] !== 'undefined'){

            this.getTemplateViewModel().orderByDirection(params['orderByDirection']);
        }

        if(typeof params['orderByAndDirection'] !== 'undefined'){

            this.getTemplateViewModel().orderByAndDirection(params['orderByAndDirection']);
        }

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);
    }

    public calculateColumnCount(){

        // Article section: Art., Act. Sess./Art., then financial/cost columns (Req./Sess. and Imp./Sess. moved to Engagement).
        let articleSectionColumnCount = 2;

        // Engagement section: AVD, Sign-up Ratio, Activity Ratio, Req./Sess. and Imp./Sess.
        let engagementSectionColumnCount = 5;

        // Overview colspan: Act. Sess., US Traffic%, then permission/collapse-dependent columns.
        let overviewSectionColumnCount = 2;

        if (this.getTemplateViewModel().costPermissions()) {

            articleSectionColumnCount += 2;
            overviewSectionColumnCount += 3;
        }

        if (this.getTemplateViewModel().financialPermissions()) {

            articleSectionColumnCount += 4;
            overviewSectionColumnCount += 1;
        }

        if (this.getTemplateViewModel().costPermissions() && this.getTemplateViewModel().financialPermissions()) {

            articleSectionColumnCount += 0;
            overviewSectionColumnCount += 1;
        }

        if (this.getTemplateViewModel().collapseButtonText() == 'simplify') {

            overviewSectionColumnCount += 1;

            if (this.getTemplateViewModel().costPermissions() && this.getTemplateViewModel().costBreakdownPermissions()) {

                articleSectionColumnCount += 3;
                overviewSectionColumnCount += 0;
            }

            if (this.getTemplateViewModel().costPermissions()) {

                articleSectionColumnCount += 0;
                overviewSectionColumnCount += 0;
            }
        }

        this.getTemplateViewModel().articleSectionColumnCount(articleSectionColumnCount);
        this.getTemplateViewModel().engagementSectionColumnCount(engagementSectionColumnCount);
        this.getTemplateViewModel().overviewSectionColumnCount(overviewSectionColumnCount);
        // engagementSectionColumnCount already set above (always 5).
    }

    public setPermissions(permissions){

        if (permissions['roi tool page cost'].read) {

            this.getTemplateViewModel().collapseButtonHidden(0);
        }

        this.getTemplateViewModel().costPermissions(permissions['roi tool page cost'].read);
        this.getTemplateViewModel().financialPermissions(permissions['roi tool page financial'].read);
        this.getTemplateViewModel().costBreakdownPermissions(permissions['roi tool page cost breakdown'].read);
        this.getTemplateViewModel().reconciliationPermissions(permissions['roi tool page reconciliation data'].read);

        this.calculateColumnCount();
    }

    public setDataRangesItems(){

        this.getTemplateViewModel().dataRanges(this.dataRanges);
    }

    private onDataRangeChange(data){

        this.initializeToolTips();
        this.caller.getListData();
    }

    public setPrimaryCategoriesFilterItems(items){

        this.primaryCategoriesFilter.setItems(items);
    }

    public setSrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.srEditorsFilter.setItems(items);
    }

    public setJrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.jrEditorsFilter.setItems(items);
    }

    private onPublishStatusChange(){

        this.caller.getListData();
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/contentInvestment_template.ts